import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { OrderMatchOfferToProductCommand, OrderMatchOfferToProductCommandBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(OrderMatchOfferToProductCommand)
@Injectable({ providedIn: 'root'})
export class OrderMatchOfferToProductCommandHandler {
	private commandHandler: OrderMatchOfferToProductCommandBase;
	public constructor(
		@Inject(Http) http: HttpService
	) {
		this.commandHandler = new OrderMatchOfferToProductCommandBase(http);
	}

	public async handleAsync(query: OrderMatchOfferToProductCommand): Promise<any> {
		return await this.commandHandler.handleAsync(query);
	}
}
